export const FAULTINJECT_GET_NOTIFICATIONS = 'faultInject_getNotifications';
export const FAULTINJECT_GET_NOTIFICATIONS_VALUE = 'value_1';
export const FAULTINJECT_UPDATE_READ_NOTIFICATIONS =
  'faultInject_updateReadNotifications';
export const FAULTINJECT_UPDATE_READ_NOTIFICATIONS_VALUE = 'value_1';

export const SUCCESS = 'success';
export const REJECTED = 'rejected';

export const FETCH_NOTIFICATIONS_TAG = 'FETCH_NOTIFICATIONS';
